const config2 = {
//    serverBaseUrl: process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:8080'
    serverBaseUrl: 'api.thenetworktimes.xyz' || 'http://localhost:8080'
};

export default config2;
